/**=========================================================
 * Module: app-progress.js
 * Counter widget
 =========================================================*/

App.directive('appProgress', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/progress.html',
      //controller: 'CounterController',
      restrict: 'E',
      replace: true,
      scope: { 
          value: '=value',
          type: '=type'
      }
  };

});
